import { render, staticRenderFns } from "./TextHTML.vue?vue&type=template&id=17d6bfce&lang=pug"
import script from "./TextHTML.vue?vue&type=script&lang=ts"
export * from "./TextHTML.vue?vue&type=script&lang=ts"
import style0 from "./TextHTML.vue?vue&type=style&index=0&id=17d6bfce&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports